import React from 'react'
import theme from '../../styles/theme'
import Box, { BoxProps } from '../primitives/Box'
import { Caret } from './Caret'
import { isSubMenu, menuItems } from './MenuItems'

type Props = {
  isDark?: boolean
}

const DesktopMenu = ({ isDark }: Props) => {
  const itemProps: BoxProps<'a'> = {
    font: 'small',
    margin: 0,
    padding: 0,
    fontWeight: 500,
    color: isDark ? 'white' : 'black900',
    paddingX: 8,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 4,
  }
  const hoverCss = `&:hover .item {
    color: ${isDark ? theme.colors.white : theme.colors.black900};
    background: ${
      isDark ? 'rgba(255,255,255,.2)' : theme.colors.hoverHighlight
    };
  }`

  return (
    <Box.ul
      paddingX={0}
      paddingY={4}
      display="flex"
      css={`
        user-select: none;
        list-style: none;

        li {
          padding: 0;
          margin: 0;
        }
      `}
      gap={8}
    >
      {menuItems.map(item =>
        isSubMenu(item) ? (
          <Box.li
            key={item.text}
            className="sub-menu"
            css={`&:hover .sub-menu-wrapper { display: block; }` + hoverCss}
          >
            <Box.span {...itemProps} className="item" cursor="default">
              {item.text}
              <Caret />
            </Box.span>
            <Box className="sub-menu-wrapper" display="none">
              {item.render()}
            </Box>
          </Box.li>
        ) : (
          <Box.li key={item.href} css={hoverCss}>
            {item.href.startsWith('http') ? (
              <Box.a
                {...itemProps}
                href={item.href}
                target="_blank"
                className="item"
              >
                {item.text}
              </Box.a>
            ) : (
              <Box.Link {...itemProps} to={item.href} className="item">
                {item.text}
              </Box.Link>
            )}
          </Box.li>
        ),
      )}
    </Box.ul>
  )
}

export default DesktopMenu
